import dataLayer from 'assets/core/js/page/red-booking/customer-zone/dataLayer'
import plainPassword from 'assets/themes/campings/js/module/plainPassword'
import cancellationPages from 'assets/themes/campings/js/page/red-booking/customer-zone/cancellationPages'
import paymentScheduleToggle from 'assets/themes/campings/js/page/red-booking/customer-zone/paymentScheduleToggle'

const currentPageType = document.body.getAttribute('data-pagetype') as string

document.addEventListener('DOMContentLoaded', function () {
  if (/(customer-zone-subscribe|customer-zone-login|customer-zone-new-password)/.test(currentPageType)) {
    plainPassword.init()
  }

  dataLayer()
  paymentScheduleToggle()
  cancellationPages()
})
